module.exports = __webpack_public_path__ + "static/media/staytion-logo-icon.61d1f9d1.png";